// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cIv2mU0MJXkXwOZfYQhJ {
   border-top: 1px solid #ccc;
   border-bottom: 1px solid #ccc;
   padding: 2px 0px;
   color: #f47d16;
}
`, "",{"version":3,"sources":["webpack://./Shared/prosemirror/tiptap/extensions/featuredQuote.module.css"],"names":[],"mappings":"AAAA;GACG,0BAA0B;GAC1B,6BAA6B;GAC7B,gBAAgB;GAChB,cAAc;AACjB","sourcesContent":[".featuredQuote {\n   border-top: 1px solid #ccc;\n   border-bottom: 1px solid #ccc;\n   padding: 2px 0px;\n   color: #f47d16;\n}\n"],"sourceRoot":""}]);
// Exports
export var featuredQuote = `cIv2mU0MJXkXwOZfYQhJ`;
export default ___CSS_LOADER_EXPORT___;
